import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar/Navbar";
import { Breadcrumb, Button, Drawer, Select } from "antd";
import { DoubleRightOutlined, DownloadOutlined } from "@ant-design/icons";
import ShimmerLoader from "../../loading";
import "../../styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { routes } from "../../Routes";
import LoadingSpinner from "../../components/Loading";
import {
  fetchAllVendors,
  getVendors,
} from "../../API  Functions/PurchaseFunctions";
import SearchBox from "../../components/CustomWidgets/SearchBox";
import { debounce } from "@mui/material";
import {
  cashInOutReport,
  getCreditHistory,
  getPosOrderLines,
  posOrders,
} from "../../API  Functions/SessionHistoryFunctions";
import CreditHistoryTable from "./CreditHistoryTable";
import CashiInOutTable from "./CashInOutTable";
import { getStoreUsers } from "../../API  Functions/UserMangement";
import PosOrderTable from "./PosOrdersTable";
import DateFilter from "../../components/ui/DateFilter";
import dayjs from "dayjs";
import ExportCasInOutReportModal from "./ExportCasInOutReportModal";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import i18next from "i18next";
import { toast } from "react-toastify";
import moment from "moment";
import { checkPermission } from "../../Utils/permissionHelper";

const PosOrders = () => {
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const [loading, setloading] = useState(false);
  const { Option } = Select;
  const [data, setData] = useState([]);
  const [currentLimit, setCurrentLimit] = useState(10); // Default limit
  const [currentOffset, setCurrentOffset] = useState(0); // Default offset
  const [query, setquery] = useState("");
  const [cashiInOutData, setCashiInOutData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [orders, setOrders] = useState([]);
  const [selectedRange, setSelectedRange] = useState("thisMonth");
  const today = dayjs();
  const formatToday = today.format("YYYY-MM-DD");
  const startofMonth = today.startOf("month").format("YYYY-MM-DD");
  const [startDate, setStartDate] = useState(startofMonth);
  const [endDate, setEndDate] = useState(formatToday);
  const [exportModalOpen, setExportModalOpen] = useState(false);

  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );
  const isGinne = useSelector(
    (state) => state?.geneLoginReducer?.isGinneLogin
  );

  const [drawerVisible, setDrawerVisible] = useState(false);
  const [drawerLoading, setDrawerLoading] = useState(false);
  const [drawerData, setDrawerData] = useState(null);
  const [orderLines, setOrderLines] = useState([]);

  useEffect(() => {
    // if (user_id) {
    GetPosOrder(selectedUser, query, startDate, endDate);
    // }
  }, [currentLimit, currentOffset]);

  useEffect(() => {
    GetUserData();
  }, []);

  const GetUserData = async () => {
    try {
      const res1 = await getStoreUsers(user_id);

      if (res1?.result[0]?.status_code === 200) {
        const activeUsers = res1.result[0]?.response?.filter(
          (user) => user.active === true
        );
        setUserData(activeUsers);
      } else {
        setUserData([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setloading(false);
    }
  };

  const GetPosOrder = async (user, text, start, end) => {
    const payload = {
      store_id: company_id,
      order_no: text, // optional
      //   "customer": text,              // optional
      offset: currentOffset,
      limit: currentLimit,
      start_date: start,
      end_date: end,
      ...(user && { user_id: user }),
    };
    try {
      const res1 = await posOrders(payload);

      if (res1?.result?.status_code === 200) {
        setOrders(res1?.result?.order_list);
      } else {
        setOrders([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setloading(false);
    } finally {
      setloading(false);
    }
  };

  const handleOptionChange = (selectedValue) => {
    setloading(true);
    if (selectedValue === "All Users") {
      setSelectedUser(null); // Reset selected category
      GetPosOrder(null, "", startDate, endDate); // Fetch all products
    } else {
      setSelectedUser(selectedValue);
      if (selectedValue) {
        GetPosOrder(selectedValue, "", startDate, endDate);
      }
    }
  };

  const debouncedSearch = debounce((value) => {
    setquery(value);
    setloading(true);
    setSelectedRange("thisMonth");
    setStartDate(startofMonth);
    setEndDate(formatToday);
    setSelectedUser(null); // Reset selected category
    GetPosOrder("", value, startofMonth, formatToday);
  }, 1000);

  const handleRowClick = async (order) => {
    setDrawerVisible(true);
    setDrawerLoading(true);
    setDrawerData(order);

    console.log("vdfggv", order);

    try {
      const payload = {
        order_id: order.id,
        lang: i18n.language === "ar" ? "ar_001" : "en_US",
      };
      const res = await getPosOrderLines(payload);

      if (res?.result?.status_code === 200) {
        setOrderLines(res?.result?.records || []);
        console.log("Order Lines Response:", orderLines);
      } else {
        setOrderLines([]);
      }
    } catch (error) {
      console.error("Error fetching order lines:", error);
    } finally {
      setDrawerLoading(false);
    }
  };

  const onClose = () => {
    setDrawerVisible(false);
    setOrderLines([]);
  };

  const handleExport = async (dates) => {
    let payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      start_date: dates?.startDate,
      end_date: dates?.endDate,
      store_id: company_id,
    };
    const response = await axiosInstance.post(
      URLS.GET_POS_ORDERS_EXCEL,
      payload
    );
    if (response?.data?.result?.status_code == 200) {
      setExportModalOpen(false);
      downloadFile(response?.data?.result?.file_data);
    } else {
      toast.error(response?.data?.result.status);
    }
  };

  const downloadFile = (base64Data) => {
    try {
      if (
        !base64Data ||
        typeof base64Data !== "string" ||
        base64Data.trim() === ""
      ) {
        alert("No valid file data available for download");
        return;
      }

      let cleanBase64 = base64Data
        .trim()
        .replace(/^data:[\w/+-]+;base64,/, "")
        .replace(/^["']|["']$/g, "")
        .replace(/\s/g, "");

      const padLength = 4 - (cleanBase64.length % 4);
      if (padLength < 4) cleanBase64 += "=".repeat(padLength);

      let binaryString = atob(cleanBase64);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      const header = new Uint8Array(bytes.buffer, 0, 8);
      let mimeType = "application/octet-stream";
      let fileExtension = "bin";

      if (header[0] === 0x50 && header[1] === 0x4b) {
        mimeType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        fileExtension = "xlsx";
      } else if (
        header[0] === 0xd0 &&
        header[1] === 0xcf &&
        header[2] === 0x11 &&
        header[3] === 0xe0
      ) {
        mimeType = "application/vnd.ms-excel";
        fileExtension = "xls";
      } else if (new TextDecoder().decode(header).includes(",")) {
        mimeType = "text/csv";
        fileExtension = "csv";
      }

      const blob = new Blob([bytes], { type: mimeType });
      // const timestamp = new Date()
      //   .toISOString()
      //   .replace(/[:.]/g, "-")
      //   .replace("T", "_")
      //   .slice(0, 19);
      // const filename = `cashier_orders_${timestamp}.${fileExtension}`;
      const timestamp = moment().format('YYYY-MM-DD_HH.mm.ss'); // Using period for time
      const filename = `${t('cashier_orders')}_${timestamp}.${fileExtension}`;
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error("File download failed:", error);
      alert(`Download failed: ${error.message || "Unknown error"}`);
    }
  };

  return (
    <>
      <div className="w-full flex flex-col md:h-full pb-2 overflow-y-auto  bg-[#F6F7F9]">
        <Navbar heading="Cashier Orders" />
        <div className="flex-grow overflow-y-auto custom-scrollbar overflow-hidden ms-3 mt-2">
          <div className="font-extrabold mb-3">
            {/* <Breadcrumb
              separator={<DoubleRightOutlined />}
              items={[
                {
                  title: <Link to={routes.purchase}>{t("Cashier")}</Link>,
                  key: "purchase",
                },
                { title: t("Cashier Orders") },
              ]}
              className="relative mt-3 font-semibold"
            /> */}
          </div>

          <div className=" mt-3">
            <div className="flex items-center">
              <SearchBox
                // showBarcode={true}
                searchResult={(values) => debouncedSearch(values)}
                placeholder={t("Search Receipt Number, Customer")}
              />
              <Select
                className="overflow-hidden mx-3"
                style={{
                  width: 200,
                  minWidth: 200,
                  height: 40,
                }}
                placeholder={t("Select User")}
                value={selectedUser || "All Users"} // Set default value to "All Categories"
                onChange={handleOptionChange} // Keep this as is
              >
                <Option value="All Users">{t("All Users")}</Option>{" "}
                {Object.values(userData)?.map((option) => {
                  const { user_id, name, phone, email } = option;
                  let displayText = name;

                  if (phone) {
                    displayText += ` (${phone})`;
                  } else if (email) {
                    displayText += ` (${email})`;
                  }

                  return (
                    <Option key={user_id} value={user_id}>
                      {displayText}
                    </Option>
                  );
                })}
              </Select>
              <div className=" mb-2">
                <DateFilter
                  setSelectedRange={setSelectedRange}
                  selectedRange={selectedRange}
                  SubmitFilter={(start, end) => {
                    setStartDate(start);
                    setEndDate(end);
                    setquery("");
                    setSelectedUser(null);
                    GetPosOrder(null, "", start, end);
                  }}
                />
              </div>
            </div>
            <div className=" flex justify-end mt-3 mx-8">
              <button
                className="w-48 h-10 bg-primaryBlue text-white text-sm font-semibold rounded-lg flex items-center justify-center gap-2"
                // onClick={() => setExportModalOpen(true)}
                onClick={() => {
                  if (checkPermission("/pos/orders", isGinne)) {
                    setExportModalOpen(true);
                  }
                }}
              >
                <DownloadOutlined
                  style={{ fontSize: "1.5em", MozMarginStart: -10 }}
                />

                <span>{t("Download in Excel")}</span>
              </button>
            </div>
            {loading ? (
              <ShimmerLoader />
            ) : (
              <>
                <PosOrderTable
                  additionalData={orders}
                  pagination={(values) => {
                    setCurrentLimit(values.limit);
                    setCurrentOffset(values.offset);
                  }}
                  onRowClick={handleRowClick}
                />
              </>
            )}
          </div>
        </div>
      </div>

      {/* Drawer */}
      <Drawer
        title={
          drawerData
            ? `Receipt No. ${drawerData.receipt_no}`
            : t("Order Details")
        }
        placement={i18n.language === "ar" ? "left" : "right"}
        width={500}
        onClose={onClose}
        visible={drawerVisible}
        styles={{
          header: {
            color: "#1E3ABA", // Change this to your desired color
            fontWeight: "bold",
            fontSize: "20px",
          },
        }}
      >
        {drawerLoading ? (
          <div className="space-y-4 p-4">
            {/* Header Skeleton */}
            <div className="h-6 bg-gray-200 rounded animate-pulse w-1/2"></div>

            {/* Summary Skeleton */}
            <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded animate-pulse w-3/4"></div>
              <div className="h-4 bg-gray-200 rounded animate-pulse w-2/3"></div>
              <div className="h-4 bg-gray-200 rounded animate-pulse w-1/2"></div>
            </div>

            {/* Product Line Skeletons */}
            {[1, 2, 3].map((_, idx) => (
              <div
                key={idx}
                className="flex items-center space-x-3 border rounded-lg bg-white p-3 shadow-sm animate-pulse"
              >
                <div className="w-10 h-10 bg-gray-200 rounded"></div>
                <div className="flex-1 space-y-2">
                  <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                  <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                </div>
                <div className="h-4 bg-gray-200 rounded w-10"></div>
              </div>
            ))}
          </div>
        ) : // <LoadingSpinner />
          // <div>{t("Loading order details...")}</div>
          drawerData ? (
            <div className="space-y-4">
              {/* Order Summary */}
              <div className="space-y-1 text-sm font-medium">
                <p>
                  <strong>{t("Order Value :")}</strong> {drawerData.currency}{" "}
                  {drawerData.order_value}
                </p>
                <p>
                  <strong>{t("Total Amount :")}</strong> {drawerData.currency}{" "}
                  {drawerData.order_value}
                </p>
                <p>
                  <strong>{t("Number of Items :")}</strong> {drawerData.items}
                </p>
                <p>
                  <strong>{t("Payment Mode :")}</strong>{" "}
                  {drawerData.payment || "-"}
                </p>
                <p>
                  <strong>{t("Payment Status :")}</strong>{" "}
                  {drawerData.state || "-"}
                </p>
              </div>

              {/* Product Lines */}
              <div>
                {orderLines.map((line, index) => (
                  <div
                    key={index}
                    className="flex justify-between items-center border rounded-lg bg-white p-2 mb-2 shadow-sm"
                  >
                    {/* Image */}
                    <img
                      src={line.image_url || "/placeholder.png"}
                      alt={line.name}
                      className="w-10 h-10 object-contain rounded"
                    />

                    {/* Middle content: Name + Qty x Price */}
                    <div className="flex flex-col flex-1 mx-2">
                      <p className="font-semibold text-sm leading-tight">
                        {line.name}
                      </p>
                      <p className="text-xs text-gray-600">
                        {line.qty} x {line.price} {line.currency}
                      </p>
                    </div>

                    {/* Right: Total price */}
                    <p className="font-normal whitespace-nowrap text-right">
                      {line.currency} {(line.price * line.qty).toFixed(2)}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <p>{t("no_product_found")}</p>
          )}
      </Drawer>
      {exportModalOpen && (
        <ExportCasInOutReportModal
          heading={t("Download Cashier Orders")}
          isOpen={exportModalOpen}
          onClose={() => setExportModalOpen(false)}
          onExport={(dates) => handleExport(dates)}
        />
      )}
    </>
  );
};

export default PosOrders;
